import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import StewartInput from "controls/global/stewart-input";
import React, { useRef, useState } from "react";
import DecimalNumberFormat from "../shared/DecimalNumberFormat";

interface Props {
  name: string;
  disabled?: boolean;
  onChange: (name: string, value: string | null) => void;
  defaultValue?: string;
  // Opt-in only: this component also backs the free-text header searches
  // (PolicyNumberList, AgentIDList, ReportingID, MunicipalityNum), so the
  // numeric mask must never be unconditional.
  numeric?: boolean;
  decimalScale?: number;
}

const InputSearch = ({
  name,
  disabled,
  onChange,
  defaultValue,
  numeric,
  decimalScale = 2,
}: Props) => {
  const [value, setValue] = useState<string>(defaultValue ? defaultValue : "");
  const searchInputRef = useRef<HTMLInputElement>(null);

  const clearInput = () => {
    setValue("");
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
      const changeEvent = {
        target: searchInputRef.current,
      } as React.ChangeEvent<HTMLInputElement>;
      handleInputChange(changeEvent);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fieldName = event.target.name;
    const currentValue = event.target.value;
    if (value !== event.target.value.trim()) {
      onChange(fieldName, currentValue);
    }
    setValue(currentValue || "");
  };

  return (
    <StewartInput
      {...{ name }}
      id={name}
      fullWidth
      onChange={handleInputChange}
      disabled={disabled}
      placeholder="Search"
      inputRef={searchInputRef}
      InputProps={{
        endAdornment: !!value && (
          <IconButton onClick={clearInput} disabled={disabled}>
            <CloseIcon />
          </IconButton>
        ),
        ...(numeric ? { inputComponent: DecimalNumberFormat as any } : {}),
      }}
      {...(numeric ? { inputProps: { decimalScale } } : {})}
      value={value}
    />
  );
};

export default InputSearch;
